module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-box",
    on: {
      "click": _vm.change
    }
  }, [_c('div', {
    staticClass: "content",
    class: {
      active: _vm.val
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7df3faff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/Form/RadioBox.vue
// module id = 634
// module chunks = 1